
import { FormEvent } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { EmojiSelector } from "./EmojiSelector";
import { DailyTargetInput } from "./DailyTargetInput";
import { PrioritySelector } from "./PrioritySelector";
import { Priority } from "@/types/habit";

interface AddHabitFormProps {
  title: string;
  setTitle: (value: string) => void;
  selectedEmoji: string;
  setSelectedEmoji: (emoji: string) => void;
  days: string;
  setDays: (value: string) => void;
  reward: string;
  setReward: (value: string) => void;
  priority: Priority;
  setPriority: (value: Priority) => void;
  dailyTargetValue: string;
  setDailyTargetValue: (value: string) => void;
  dailyTargetUnit: string;
  setDailyTargetUnit: (value: string) => void;
  hasDailyTarget: boolean;
  setHasDailyTarget: (value: boolean) => void;
  emojiOptions: string[];
  measurementUnits: string[];
  onSubmit: (e: FormEvent) => void;
}

export const AddHabitForm = ({
  title,
  setTitle,
  selectedEmoji,
  setSelectedEmoji,
  days,
  setDays,
  reward,
  setReward,
  priority,
  setPriority,
  dailyTargetValue,
  setDailyTargetValue,
  dailyTargetUnit,
  setDailyTargetUnit,
  hasDailyTarget,
  setHasDailyTarget,
  emojiOptions,
  measurementUnits,
  onSubmit
}: AddHabitFormProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4 px-6 pt-2 pb-4">
      <div className="space-y-2">
        <Label htmlFor="title">Habit Name</Label>
        <Input
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter habit name"
          required
          className="border-primary/30 focus:border-primary rounded-[--radius]"
        />
      </div>
      
      <EmojiSelector
        selectedEmoji={selectedEmoji}
        onSelect={setSelectedEmoji}
        emojiOptions={emojiOptions}
      />

      <div className="space-y-2">
        <Label htmlFor="days">Challenge Duration (Days)</Label>
        <Input
          id="days"
          type="number"
          min="1"
          value={days}
          onChange={(e) => setDays(e.target.value)}
          required
          className="border-primary/30 focus:border-primary rounded-[--radius]"
        />
      </div>

      <DailyTargetInput
        hasDailyTarget={hasDailyTarget}
        setHasDailyTarget={setHasDailyTarget}
        dailyTargetValue={dailyTargetValue}
        setDailyTargetValue={setDailyTargetValue}
        dailyTargetUnit={dailyTargetUnit}
        setDailyTargetUnit={setDailyTargetUnit}
        measurementUnits={measurementUnits}
      />

      <div className="space-y-2">
        <Label htmlFor="reward">Reward</Label>
        <Input
          id="reward"
          value={reward}
          onChange={(e) => setReward(e.target.value)}
          placeholder="What's your reward for completing this?"
          className="border-primary/30 focus:border-primary rounded-[--radius]"
        />
      </div>

      <PrioritySelector 
        priority={priority} 
        onChange={setPriority} 
      />

      <Button type="submit" className="w-full bg-primary hover:bg-primary-dark text-white">
        Create Habit
      </Button>
    </form>
  );
};
